module.exports = __webpack_public_path__ + "static/media/img2.787f2849.jpg";